// extracted by mini-css-extract-plugin
module.exports = {"Header_Wrap":"ReportResult_Header_Wrap__I05sA"};